import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import webviewHandler from '@flipster/utils/webview-handler';

const WebviewFooter = () => {
  return (
    <footer
      className={css({
        position: 'fixed',
        bgColor: 'background.default.level-0',
        bottom: 0,
        left: 0,
        right: 0,
        px: 16,
        pt: 16,
        pb: 24,
      })}
    >
      <Button
        label={<FormattedMessage id='Common.r250918.Got_it' />}
        css={{ width: '100%' }}
        onClick={() => webviewHandler.postMessage({ action: 'close' })}
      />
    </footer>
  );
};

export default WebviewFooter;
